import { Col, Form, Input, Row } from 'antd'
import { translate } from '../../../core'
import React from 'react'
import styles from './WeddingRegistry.module.scss'
import { InputCard } from '../../inventory/component/InputCard'

export const WeddingRegistryFormSpouse = () => {
  return (
    <InputCard
      title={translate("spouse_2")}
      contained
      className='mt-4'
    >
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Form.Item
            label={translate("NameFirst")}
            name={['otherSpouse','firstName']}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={translate('Last')}
            name={['otherSpouse','lastName']}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={translate('Phone')}
            name={['otherSpouse','homePhone']}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={translate('email')}
            name={['otherSpouse','email']}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </InputCard>
  )
}